import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid, Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useToast, useFetch, useModal, useGrid, useAuth, useResource, usePage } from "@/comn/hooks";
import {
    URLS,
    APIS,
    SF_MANL_RCPT_SRCH,
    SF_MANL_RCPT_SAVE,
    SF_MANL_RCPT_DTL,
    SG_RCPT_BLL_DTL_LIST,
} from "./services/OsciRcptService"; // 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Manual Receipt Registration
 * !== 수작업 수납 등록 ==!
 */
export const OSCI0402007S = () => {
    const resource = useResource({
        defaultSchema: [],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { mode, scrnTp, bllNo } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    let pgeTitle = "";

    if (menuId?.includes("menu_coli")) {
        pgeTitle = "T_MANL_RCPT_RGSR";
    } else if (menuId?.includes("menu_olmi")) {
        pgeTitle = "T_OIL_MANL_RCPT_RGSR";
    }

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0056" },
            { area: "comnCd", comnCd: "OSC0058" },
            { area: "comnCd", comnCd: "OSC0065" },
            { area: "comnCd", comnCd: "OSC0067" },
            { area: "comnCd", comnCd: "OSC0020" },
            { area: "coCd" },
            { area: "bnkCd" },
            { area: "cstmCd" },
        ],
    });

    const [vsbSaveBtn, setVsbSaveBtn] = useState(false);
    const [vsbTrsyVchr, setVsbTrsyVchr] = useState(false);
    const [vsbSrchBtn, setVsbSrchBtn] = useState(false);
    const [vsbCn, setVsbCn] = useState(false);

    const [vsbCashr, setVsbCashr] = useState(false);
    const [vsbOthr, setVsbOthr] = useState(false);
    const [vsbManlRcpt, setVsbManlRcpt] = useState(true);
    const [vsbManlRcptView, setVsbManlRcptView] = useState(false);
    const [vsdDtls, setVsdDtls] = useState(false);

    const [bllDtlList, setBllDtlList] = useState(comnUtils.getGridData([]));

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */

    const form = {
        // Manual Receipt Search !== 수작업 수납 검색 ==!
        manlRcptSrch: useForm({
            defaultSchema: SF_MANL_RCPT_SRCH,
            defaultValues: {},
        }),
        // Manual Receipt General !== 수작업 수납 일반 ==!
        manlRcptGnrl: useForm({
            defaultSchema: SF_MANL_RCPT_SAVE,
            defaultValues: {},
        }),
        // Manual Receipt View !== 수작업 수납 view ==!
        manlRcptView: useForm({
            defaultSchema: SF_MANL_RCPT_DTL,
            defaultValues: {},
        }),
    };

    const today = new Date();

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Detail List !== 고지 상세 목록 ==!
        bllDtlList: useGrid({
            defaultSchema: SG_RCPT_BLL_DTL_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */

    const readyFunc = {
        readyBll: (data: any) => {
            form.manlRcptGnrl.setValues({
                ...data.manlRcptDtl.content,
            });

            form.manlRcptView.setValues({
                ...data.manlRcptDtl.content,
            });

            form.manlRcptSrch.setEditable(false);
            setVsbSrchBtn(false);

            if (data.manlRcptDtl.content != null) {
                setVsbCn(true);
            }

            if (data.manlRcptDtl.content.reffKeyTpCd == null || data.manlRcptDtl.content.reffKeyTpCd == "") {
                form.manlRcptGnrl.setValue("reffKey", "");
            } else {
                if (data.manlRcptDtl.content.reffKeyTpCd == "T") {
                    form.manlRcptGnrl.setValue(
                        "reffKey",
                        data.manlRcptDtl.content.reffKeyNo1 +
                            "-" +
                            data.manlRcptDtl.content.reffKeyNo2 +
                            "-" +
                            data.manlRcptDtl.content.reffKeyNo3,
                    );
                } else if (data.manlRcptDtl.content.reffKeyTpCd == "A") {
                    form.manlRcptGnrl.setValue("reffKey", data.manlRcptDtl.content.reffKeyNo1);
                } else {
                    form.manlRcptGnrl.setValue(
                        "reffKey",
                        data.manlRcptDtl.content.reffKeyNo1 +
                            "-" +
                            data.manlRcptDtl.content.reffKeyNo2 +
                            (data.manlRcptDtl.content.reffKeyNo3 ? "-" + data.manlRcptDtl.content.reffKeyNo3 : "") +
                            (data.manlRcptDtl.content.reffKeyNo4 ? "-" + data.manlRcptDtl.content.reffKeyNo4 : ""),
                    );
                }
            }

            if (data.manlRcptDtl.content.pyerTpCd == "T") {
                if (data.manlRcptDtl.content.pyerNm != null && data.manlRcptDtl.content.pyerNm != "") {
                    form.manlRcptGnrl.setValue(
                        "pyerMgmtNoNm",
                        colUtils.setMask(data.manlRcptDtl.content.pyerMgmtNo, "tin") +
                            " (" +
                            data.manlRcptDtl.content.pyerNm +
                            ")",
                    );
                } else {
                    form.manlRcptGnrl.setValue(
                        "pyerMgmtNoNm",
                        colUtils.setMask(data.manlRcptDtl.content.pyerMgmtNo, "tin"),
                    );
                }
            } else {
                if (data.manlRcptDtl.content.pyerMgmtNo == null || data.manlRcptDtl.content.pyerMgmtNo == "") {
                    form.manlRcptGnrl.setValue("pyerMgmtNoNm", data.manlRcptDtl.content.pyerNm);
                } else {
                    if (data.manlRcptDtl.content.pyerNm != null && data.manlRcptDtl.content.pyerNm != "") {
                        form.manlRcptGnrl.setValue(
                            "pyerMgmtNoNm",
                            colUtils.setMask(data.manlRcptDtl.content.pyerMgmtNo, "tin") +
                                " (" +
                                data.manlRcptDtl.content.pyerNm +
                                ")",
                        );
                    } else {
                        form.manlRcptGnrl.setValue(
                            "pyerMgmtNoNm",
                            colUtils.setMask(data.manlRcptDtl.content.pyerMgmtNo, "tin"),
                        );
                    }
                }
            }

            const bllRgsrNm = data.manlRcptDtl.content.bllRgsrNm;
            form.manlRcptGnrl.setValue(
                "bllRgsrIdNm",
                data.manlRcptDtl.content.bllRgsrId + (bllRgsrNm ? "/" + data.manlRcptDtl.content.bllRgsrNm : ""),
            );
            form.manlRcptGnrl.setValue("rcptAmt", data.manlRcptDtl.content.feeAmt);

            if (data.manlRcptDtl.content.bllTpCd && data.manlRcptDtl.content.bllTpCd === "G") setVsdDtls(true);
            if (data.manlRcptDtl.content.bllDtls) {
                setBllDtlList(comnUtils.getGridData(data.manlRcptDtl.content.bllDtls));
            }
        },
        readyManlRcpt: (data: any) => {
            const bllStatCd = data.manlRcptDtl.content.bllStatCd;

            setVsbTrsyVchr(false);
            setVsbCashr(false);
            setVsbOthr(false);
            setVsbSaveBtn(false);
            setVsbManlRcpt(true);
            setVsbManlRcptView(false);

            setVsbOthr(true);
            form.manlRcptGnrl.setEditable("payMetdCdSec", true);

            if (bllStatCd == "C") {
                form.manlRcptGnrl.setEditable("payMetdCdSec", false);
                form.manlRcptGnrl.setEditable("rcptDt", false);
                form.manlRcptGnrl.setEditable("rcptAmt", false);
                setVsbOthr(false);
            } else {
                setVsbManlRcpt(true);
                setVsbSaveBtn(true);
                form.manlRcptGnrl.setEditable("rcptDt", true);
                form.manlRcptGnrl.setValue("rcptDt", today);
            }
        },
        chkManlRcpt: (data: any) => {
            const exisYn = data.manlRcptDtl.content.exisYn;
            const sbmtYn = data.manlRcptDtl.content.sbmtYn;
            const aprvYn = data.manlRcptDtl.content.aprvYn;
            const bllPaidYn = data.manlRcptDtl.content.bllPaidYn;
            const dspoYn = data.manlRcptDtl.content.dspoYn;
            const ctrlNo = data.manlRcptDtl.content.ctrlNo;

            if (!ctrlNo) {
                modal.openModal({
                    content: "msg.osc.00268", // This bill cannot be processed because it does not have a Control Number.
                });
                return false;
            }

            if (bllPaidYn == "Y") {
                modal.openModal({
                    content: "msg.osc.00176",
                });
                return false;
            }

            if (dspoYn == "Y") {
                modal.openModal({
                    content: "msg.osc.00177",
                });
                return false;
            }

            if (exisYn == "Y") {
                if (sbmtYn == "N") {
                    modal.openModal({
                        content: "msg.osc.00178",
                    });
                    return false;
                }
                if (aprvYn == "N") {
                    modal.openModal({
                        content: "msg.osc.00179",
                    });
                    return false;
                }
            }

            return true;
        },
    };

    const fetch = {
        // Get Manual Receipt !== 수작업 수납 조회 ==!
        getManlRcpt: useFetch({
            api: (data) => APIS.getManlRcptForSave(bllNo),
            enabled: !!bllNo,
            onSuccess: (data) => {
                form.manlRcptSrch.setValues({
                    ...data.manlRcptDtl.content,
                });

                let chkFlag = true;

                if (data.manlRcptDtl.content != null) {
                    if (scrnTp == "collection") {
                        chkFlag = readyFunc.chkManlRcpt(data);
                    }

                    if (chkFlag) {
                        readyFunc.readyBll(data);
                        readyFunc.readyManlRcpt(data);
                    }
                } else {
                    modal.openModal({
                        content: "msg.osc.00182", // Please check Bill No.
                    });
                }
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00182", // Please check Bill No.
                });
            },
            showToast: true,
        }),
        // Get Manual Receipt Search !== 수작업 수납 조회 ==!
        getManlRcptSrch: useFetch({
            api: (data) => APIS.getManlRcptDtlForSave(form.manlRcptSrch.getValues()),
            onSuccess: (data) => {
                let chkFlag = true;
                const manlRcptDtl = data.manlRcptDtl.content;

                form.manlRcptSrch.setValues({
                    ...data.manlRcptDtl.content,
                });

                if (manlRcptDtl != null) {
                    if (manlRcptDtl?.bllTpCd == "G") {
                        modal.openModal({
                            content: "msg.osc.00325", // Combined bills cannot be paid manually.
                        });

                        chkFlag = false;
                    }
                    if (!manlRcptDtl?.ctrlNo) {
                        modal.openModal({
                            content: "msg.osc.00268", // This bill cannot be processed because it does not have a Control Number.
                        });
                        chkFlag = false;
                    }

                    // 이미 납부 된 경우
                    else if (manlRcptDtl?.bllPaidYn == "Y") {
                        modal.openModal({
                            content: "msg.osc.00176", // Payment has already been received, Manual Receipt cannot be registered.
                        });
                        chkFlag = false;
                    }
                    // 취소 된 경우
                    else if (manlRcptDtl?.bllStatCd == "F") {
                        modal.openModal({
                            content: "msg.osc.00177", // Notice has already been cancelled, Manual Receipt cannot be registered.
                        });
                        chkFlag = false;
                    }
                    // 기 등록 된 경우
                    else if (manlRcptDtl?.exisYn == "Y") {
                        modal.openModal({
                            content: t("msg.osc.00103", { 0: t("L_MANL_RCPT") }), // Manual Receipt is already registered.
                        });
                        chkFlag = false;
                    }

                    if (chkFlag) {
                        if (scrnTp == "collection") {
                            chkFlag = readyFunc.chkManlRcpt(data);
                        }

                        if (chkFlag) {
                            readyFunc.readyBll(data);
                            readyFunc.readyManlRcpt(data);
                        }
                    } else {
                        form.manlRcptGnrl.clearValues();
                        form.manlRcptView.clearValues();
                        setVsbCn(false);
                    }
                } else {
                    modal.openModal({
                        content: "msg.osc.00182", // Please check Bill No.
                    });

                    setVsbCn(false);
                }
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00182", // Please check Bill No.
                });
            },
            showToast: true,
        }),

        // Save Manual Receipt !== 수작업 수납 저장 ==!
        saveManlRcpt: useFetch({
            api: (data) => APIS.saveManlRcpt({ ...data, bllNo: data.bllNo ? data.bllNo : auth.get("tin"), auth, mode }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        navigate(
                            `${URLS.osci0402006q}/${data.manlRcptSaveResDto.content.bllTpCd}-${data.manlRcptSaveResDto.content.bllSysmCd}-${data.manlRcptSaveResDto.content.bllYy}-${data.manlRcptSaveResDto.content.bllSrno}-${data.manlRcptSaveResDto.content.bllDgr}-1`,
                        );
                    },
                    onCancel: () => {
                        navigate(`${URLS.osci0402007s}/${form.manlRcptGnrl.getValues().bllNo}`);
                    },
                });
            },
            onError: (error) => {
                console.log(error);
                if (error.response.status === 400) {
                    console.log(error.response.data);
                    form.manlRcptGnrl.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Manual Receipt Search !== 수작업 수납 조회 ==!
        getManlRcptSrch: () => {
            form.manlRcptSrch.handleSubmit((data) => {
                let bllNo = form.manlRcptSrch.getValue("bllNo");
                let bllTpCd = form.manlRcptSrch.getValue("bllTpCd");
                let bllSysmCd = form.manlRcptSrch.getValue("bllSysmCd");
                let bllYy = form.manlRcptSrch.getValue("bllYy");
                let bllSrno = form.manlRcptSrch.getValue("bllSrno");
                let bllDgr = form.manlRcptSrch.getValue("bllDgr");

                // Validation Check !== 밸리데이션 체크 ==!
                if (!!!bllNo && (!!!bllTpCd || !!!bllSysmCd || !!!bllYy || !!!bllSrno || !!!bllDgr)) {
                    modal.openModal({
                        content: "msg.osc.00281",
                    });
                } else {
                    form.manlRcptSrch.setValue("bllRcptSrno", "none");

                    fetch.getManlRcptSrch.fetch();
                }
            })();
        },
        // Save Manual Receipt !== 수작업 수납 저장 ==!
        saveManlRcpt: form.manlRcptGnrl.handleSubmit(
            () => {
                const data = { ...form.manlRcptGnrl.getValues() };

                if (!data.rcptNo) {
                    data.rcptNo = data.bllMgmtId;
                }

                modal.openModal({
                    content: "msg.osc.00090",
                    onConfirm: () => {
                        if (form.manlRcptGnrl.getValue("bllDt") > form.manlRcptGnrl.getValue("rcptDt")) {
                            modal.openModal({
                                content: "msg.osc.00187",
                            });
                            return;
                        }

                        fetch.saveManlRcpt.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
        chgRcptTp: (e: any) => {
            if (e == "U") {
                setVsbCashr(false);
            } else if (e == "C") {
                setVsbCashr(true);
            }
        },
    };

    const render = {
        grid_bllDtlList: {
            head: {},
            cell: {
                bllMgmtId: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <span>
                            {`${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`}
                        </span>
                    );
                },
            },
            edit: {},
        },
    };

    useEffect(() => {
        if (mode == "updt") {
            //form.manlRcptSrch.setEditable(false);
        } else if (mode == "new") {
            setVsbSrchBtn(true);
        }

        form.manlRcptGnrl.setEditable(false);
        form.manlRcptView.setEditable(false);
        form.manlRcptGnrl.setEditable("trsyVchrNo", true);
        form.manlRcptGnrl.setEditable("manlRcptRsn", true);
        form.manlRcptGnrl.setEditable("rcptBnkCd", true);
        form.manlRcptGnrl.setEditable("rcptBnkAcctNo", true);
        form.manlRcptGnrl.setEditable("rcptNo", true);
    }, []);

    return (
        <Page title={t(pgeTitle)}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.manlRcptSrch.schema.bllNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.manlRcptSrch.schema.bllMgmtId}></Group.Label>
                            <Group.Field size={4}>
                                <Group.Control
                                    {...form.manlRcptSrch.schema.bllTpCd}
                                    onPaste={(e: any) => {
                                        e.preventDefault();
                                        const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                        form.manlRcptSrch.setValue("bllTpCd", data.substring(0, 1));
                                        form.manlRcptSrch.setValue("bllSysmCd", data.substring(1, 5));
                                        form.manlRcptSrch.setValue("bllYy", data.substring(5, 7));
                                        form.manlRcptSrch.setValue("bllSrno", data.substring(7, 14));
                                        form.manlRcptSrch.setValue("bllDgr", data.substring(14, 15));
                                    }}
                                />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.manlRcptSrch.schema.bllSysmCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.manlRcptSrch.schema.bllYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.manlRcptSrch.schema.bllSrno} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.manlRcptSrch.schema.bllDgr} />
                            </Group.Field>
                        </Group.Row>
                    </Group.Section>
                    {vsbSrchBtn && (
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.manlRcptSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getManlRcptSrch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                </Group.Body>
            </Group>
            {vsbCn && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.bllNo} />
                                <Group.Control {...form.manlRcptGnrl.schema.bllDt} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.ctrlNo} />
                                <Group.Control {...form.manlRcptGnrl.schema.zmpDt} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.bllTpCdSec} />
                                <Group.Control {...form.manlRcptGnrl.schema.bllStatCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.pyerMgmtNoNm} />
                                <Group.Control {...form.manlRcptGnrl.schema.bllRgsrIdNm} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.reffKeyTpCd} />
                                <Group.Control {...form.manlRcptGnrl.schema.reffKey} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.feeAmt} />
                                <Group.Control {...form.manlRcptGnrl.schema.bllMgmtId} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.payDdlnDt} />
                                <Group.Control {...form.manlRcptGnrl.schema.lastDdlnXtnsDt} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.xtnsDt} />
                                <Group.Control {...form.manlRcptGnrl.schema.lastDdlnXtnsRsn} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}

            {vsdDtls && (
                <Group>
                    <Group.Body>
                        {" "}
                        <Layout direction="row">
                            <Layout.Left>
                                <Group.Title title={"T_BLL_DTL_1"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Grid {...grid.bllDtlList.grid} data={bllDtlList} render={render.grid_bllDtlList} />
                    </Group.Body>
                </Group>
            )}
            {vsbCn && vsbManlRcptView && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_MANL_RCPT"} titleSize={2}></Group.Title>

                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.manlRcptView.schema.payMetdCd} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.manlRcptView.schema.rcptBnkCd} />
                                <Group.Control {...form.manlRcptView.schema.rcptBnkAcctNo} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.manlRcptView.schema.rcptNo} />
                                <Group.Control {...form.manlRcptView.schema.manlRcptRsn} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.manlRcptView.schema.rcptAmt} />
                                <Group.Control {...form.manlRcptView.schema.rcptDt} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}

            {vsbCn && vsbManlRcpt && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_MANL_RCPT"} titleSize={2}></Group.Title>

                        <Group.Section>
                            {!vsbOthr && (
                                <Group.Row>
                                    <Group.Control {...form.manlRcptGnrl.schema.payMetdCd} />
                                </Group.Row>
                            )}
                            {vsbOthr && (
                                <Group.Row>
                                    <Group.Control
                                        {...form.manlRcptGnrl.schema.payMetdCdSec}
                                        onChange={handler.chgRcptTp}
                                    />
                                </Group.Row>
                            )}
                            {vsbTrsyVchr && (
                                <Group.Row>
                                    <Group.Control {...form.manlRcptGnrl.schema.trsyVchrNo} />
                                    <Group.Control {...form.manlRcptGnrl.schema.manlRcptRsn} />
                                </Group.Row>
                            )}
                            {!vsbTrsyVchr && !vsbCashr && (
                                <Group.Row>
                                    <Group.Control {...form.manlRcptGnrl.schema.rcptBnkCd} />
                                    <Group.Control {...form.manlRcptGnrl.schema.rcptBnkAcctNo} />
                                </Group.Row>
                            )}
                            {!vsbTrsyVchr && !vsbCashr && (
                                <Group.Row>
                                    <Group.Control {...form.manlRcptGnrl.schema.rcptNo} />
                                    <Group.Control {...form.manlRcptGnrl.schema.manlRcptRsn} />
                                </Group.Row>
                            )}
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.rcptAmt} />
                                <Group.Control {...form.manlRcptGnrl.schema.rcptDt} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0402005q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    {vsbSaveBtn && <Button role="save" onClick={handler.saveManlRcpt}></Button>}
                </Layout.Right>
            </Layout>
        </Page>
    );
};
